import { AdminPatientListResponseDto } from "@/data/dto/admin/admin-patient-list-response-dto";
import { AdminPatientTableInfoEntity } from "@/domain/entity/admin/admin-patient-table-info-entity";
import { getProgressType } from "@/utils/enum/progress-type";
import { assertAdminPatientListResponseDto } from "@/utils/validation";

export class AdminPatientListResponseMapper {
  /**
   * 환자 목록 응답 DTO를 엔티티로 변환합니다
   * @param dto - 환자 목록 응답 DTO
   * @returns 환자 테이블 정보 엔티티
   */
  static toEntity(dto: AdminPatientListResponseDto): AdminPatientTableInfoEntity {
    // AST 기반 타입 검증
    assertAdminPatientListResponseDto(dto);

    const progress =
      dto.step === undefined || dto.step === null || dto.adherence === null
        ? null
        : {
            step: dto.step,
            type: getProgressType(dto.state ?? ""),
            adherence: (dto.adherence ?? 0) * 100,
          };

    return {
      patientUuid: dto.patientUuid,
      fullName: dto.patientScreeningId,
      screeningId: dto.patientScreeningId,
      patientNumber: dto.patientScreeningId, // 스크리닝 ID를 환자 번호로 사용
      isDeactived: dto.isDeactivated,
      progress: progress,
    };
  }

  /**
   * 환자 목록 응답 DTO 배열을 엔티티 배열로 변환합니다
   * @param dtoList - 환자 목록 응답 DTO 배열
   * @returns 환자 테이블 정보 엔티티 배열
   */
  static toEntityList(dtoList: AdminPatientListResponseDto[]): AdminPatientTableInfoEntity[] {
    return dtoList.map((dto) => AdminPatientListResponseMapper.toEntity(dto));
  }
}
